export default "__VITE_ASSET__9538ac44__"